"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var copyItemsService_1 = require("../../services/copyItemsService");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var copyConversationService_1 = require("owa-mail-store/lib/services/copyConversationService");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Copy the mail list rows to a destination folder
 * @param rowKeys of the rows to copy
 * @param originalTableView which contains the rows to move from
 * @param destinationFolderId id of the destination folder to move to
 * @param sourceFolderId the actual source folder that contains the rows
 */
exports.default = legacy_1.action('copyMailListRows')(function copyMailListRows(rowKeys, originalTableView, destinationFolderId, sourceFolderId) {
    switch (originalTableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            var conversationActionContext = rowKeys.map(function (rowKey) {
                return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, originalTableView.id);
            });
            copyConversationService_1.default(conversationActionContext, destinationFolderId, sourceFolderId)
                .catch();
            break;
        case 1 /* Message */:
            var rowIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, originalTableView.id);
            copyItemsService_1.default(rowIdStrings, destinationFolderId)
                .catch();
            break;
    }
});
//# sourceMappingURL=copyMailListRows.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/copyMailListRows.js
// module id = 5593
// module chunks = 62